import './SpinLoading.less'
import SpinLoading from './SpinLoading'
export default SpinLoading
